import { classNames } from "@/react/helpers/twMergeWithCN";
import { Typography } from "@circle-react-shared/uikit/Typography";
import { Form } from "@circle-react-uikit/Form";

export interface RowProps {
  cssVariables: Record<string, string>;
  customColors?: Record<string, string>;
  name: string;
  onAddCustomColor?: (color: string) => void;
  rowClassName?: string;
  shouldRenderThemeColors?: boolean;
  shouldShowAlpha?: boolean;
  themeColors?: Record<string, string>;
  title: string;
  value: string;
}

export const Row = ({
  title,
  value,
  name,
  cssVariables,
  themeColors = {},
  shouldRenderThemeColors = true,
  shouldShowAlpha = true,
  onAddCustomColor,
  customColors,
  rowClassName,
}: RowProps) => (
  <div
    className={classNames(
      "flex items-center justify-between last:mb-5",
      rowClassName,
    )}
  >
    <Typography.LabelSm weight="semibold" color="text-dark">
      {title}
    </Typography.LabelSm>
    <div className="flex items-center gap-2">
      <Typography.LabelSm
        weight="normal"
        color="text-light"
        textTransform="uppercase"
      >
        {value}
      </Typography.LabelSm>

      <Form.ColorPickerV2
        shouldRenderThemeColors={shouldRenderThemeColors}
        shouldShowAlpha={shouldShowAlpha}
        name={name}
        cssVariables={cssVariables}
        shouldResolveCssVariable
        themeColors={themeColors}
        customColors={customColors}
        onAddCustomColor={onAddCustomColor}
      />
    </div>
  </div>
);
